import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import apiService from '../services/apiService';
import authService from '../services/authService';

const ApplicationLoginForm = ({ show, onHide }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    student_id: '',
    password: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  // Clear error when modal is hidden
  useEffect(() => {
    if (!show) {
      setError('');
      setIsLoading(false);
    }
  }, [show]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear error when user starts typing
    if (error) {
      setError('');
    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    
    try {
      const response = await apiService.studentLogin(formData);

      if (response.success && response.data.status === 'success') {
        // Store authentication data
        const { token, student } = response.data;
        authService.setAuthData(token, student);
        
        // Dispatch custom event to notify header of login success
        window.dispatchEvent(new CustomEvent('loginSuccess'));
        
       // alert(`Welcome ${student.full_name}! Redirecting to application form...`);
        onHide();
        // Reset form
        setFormData({
          student_id: '',
          password: ''
        });
        // Navigate to application form page
        navigate('/application-form');
      } else {
        setError(response.data.message || 'Login failed. Please check your credentials.');
      }
    } catch (error) {
      console.error('Login error:', error);
      setError(apiService.handleApiError(error));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="md" centered className="applic-login">
      <Modal.Header closeButton className="border-0 pb-0">
        <div className="text-center w-100">
          <img className="w-50 img-fluid text-center mx-auto" src="/assets/img/mewar-logo.png" alt="Mewar Logo" />
        </div>
      </Modal.Header>
      <Modal.Body className="popup-from pt-0">
        <div className="form-wrapper">
          <h5 className="fs-16 text-center">Log In</h5>
          {error && (
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          )}
          <form action="" method="post" id="register_form" autoComplete="off" onSubmit={handleSubmit}>
            <div className="row p-3 p-md-4">
              <div className="col-lg-12 mb-2 mb-md-4">
                <div className="inputbox">
                  <input 
                    type="text" 
                    className="form-control" 
                    autoComplete="nope" 
                    name="student_id" 
                    id="login_form_email" 
                    placeholder="Student ID ex: TEST-001" 
                    value={formData.student_id}
                    onChange={handleInputChange}
                    required 
                  />
                </div>
              </div>
              
              <div className="col-lg-12 mb-2 mb-md-4">
                <div className="inputbox">
                  <input 
                    type="password" 
                    className="form-control" 
                    autoComplete="nope" 
                    name="password" 
                    id="login_password" 
                    placeholder="Password" 
                    value={formData.password}
                    onChange={handleInputChange}
                    required 
                  />
                </div>
              </div>
              
              <div className="col-lg-12">
                <button 
                  type="submit" 
                  className="btn-get-started btnprimary w-100 text-uppercase mb-2"
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Logging in...
                    </>
                  ) : (
                    'Submit'
                  )}
                </button>
              </div>
            </div>
          </form>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ApplicationLoginForm;
